import { render, staticRenderFns } from "./dataSourceTabs.vue?vue&type=template&id=5f125572&scoped=true&"
import script from "./dataSourceTabs.vue?vue&type=script&lang=js&"
export * from "./dataSourceTabs.vue?vue&type=script&lang=js&"
import style0 from "./dataSourceTabs.vue?vue&type=style&index=0&id=5f125572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f125572",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDataTable,VTab,VTabItem,VTabs,VTabsItems})
